import { inject } from 'aurelia-framework';
import { boundMethod } from 'autobind-decorator';

@inject(Element, 'appUtils')
class OacClickOutsideCustomAttribute {
  constructor(element, appUtils) {
    this._element = element;
    this._appUtils = appUtils;
    this._subscription = null;
  }
  attached() {
    this._subscription = this._appUtils.attachWindowEvents(
      'click',
      this._onClick,
      true,
    );
  }
  detached() {
    this._subscription.dispose();
  }
  @boundMethod
  _onClick(event) {
    const { target } = event;
    if (this.value && this._element !== target && !this._element.contains(target)) {
      this.value();
    }
  }
}

export { OacClickOutsideCustomAttribute };
